define([
	"dojo/_base/declare",
	"csi/heading/RefContainer"
], function(declare,RefContainer) {

	return declare(RefContainer, {
		_sortAttribute: "SortOrder"
	});
});